import { StaticModal, createModal } from '@nexelem/modals';
import { Button } from '@nexelem/components';
import { FormProvider, useForm } from 'react-hook-form';
import { Trans } from 'react-i18next';
import { useCustomTranslation } from '../../../../../hooks';
import { z } from 'zod';
import { LotInfo } from './components/LotInfo';
import { selectOnlyTaskById, useKanbanEventStore } from '../store';
import { getExternalId } from '../utils';
import { useKanbanInProgressToPendingMutation } from './hooks';

const schema = z.object({
  reason: z.string().min(1),
});

export type ProductionPlannedSchema = z.infer<typeof schema>;

type KanbanInProgressToPendingModal = {
  id: number;
};

const KanbanInProgressToPendingModal = ({ id }: KanbanInProgressToPendingModal) => {
  const { tWrapper } = useCustomTranslation('products.productionPlan.kanban.modals.productionPlanned');
  const { mutate } = useKanbanInProgressToPendingMutation();

  const form = useForm<ProductionPlannedSchema>({
    // TODO: uncomment when BE will be ready
    // resolver: zodResolver(getSchema()),
    defaultValues: {
      reason: '',
    },
  });

  const task = useKanbanEventStore(selectOnlyTaskById(id));
  const externalId = getExternalId(task);

  if (!externalId) {
    return null;
  }

  const onSubmit = (/*data: ProductionPlannedSchema*/) => {
    mutate(
      { productionLotId: externalId },
      {
        onSettled: closeKanbanInProgressToPendingModal,
      },
    );
  };

  return (
    <StaticModal component="form" onClose={closeKanbanInProgressToPendingModal} onSubmit={form.handleSubmit(onSubmit)}>
      <StaticModal.Header withCloseButton>{tWrapper('header')}</StaticModal.Header>
      <StaticModal.Content>
        <FormProvider {...form}>
          <div className="flex flex-col gap-y-6">
            <LotInfo id={id} />
            <span className="text-s18">
              <Trans components={{ strong: <strong /> }}>{tWrapper('description')}</Trans>
            </span>
            {/* <SelectFormInput
              required
              label={tWrapper('reason')}
              maxWidth={1}
              name="reason"
              placeholder={tWrapper('reasonPlaceholder')}
              options={
                []
              }
            /> */}
          </div>
        </FormProvider>
      </StaticModal.Content>
      <StaticModal.Footer>
        <Button type="submit" variant="outlined">
          {tWrapper('move')}
        </Button>
        <Button variant="contained" onClick={closeKanbanInProgressToPendingModal}>
          {tWrapper('cancel')}
        </Button>
      </StaticModal.Footer>
    </StaticModal>
  );
};

export const { openKanbanInProgressToPendingModal, closeKanbanInProgressToPendingModal } = createModal(
  KanbanInProgressToPendingModal,
  {
    name: 'KanbanInProgressToPendingModal',
  },
);
